(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/name-input.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/name-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  byteSize,
  giftformValidator
} = svs.tickets_giftshop.functions;
const {
  NAME_MAX,
  NAME_MAX_ERROR,
  NAME_LABEL,
  NAME_REQUIRED_ERROR,
  INVALID_INPUT_ERROR
} = svs.tickets_giftshop.constants.form;
const NameInput = _ref => {
  let {
    onChange,
    value,
    onBlur,
    name
  } = _ref;
  const validationHandler = value => {
    const validationResult = {
      errorMessage: '',
      isValid: true
    };
    if (giftformValidator.hasInvalidGreetingsCharacters(value)) {
      validationResult.errorMessage = INVALID_INPUT_ERROR;
      validationResult.isValid = false;
    } else if (byteSize(value, true) > NAME_MAX) {
      validationResult.errorMessage = "".concat(NAME_MAX_ERROR, " ").concat(byteSize(value, true), "/").concat(NAME_MAX);
      validationResult.isValid = false;
    }
    return validationResult;
  };
  return React.createElement(TextInput, {
    errorMessageRequired: NAME_REQUIRED_ERROR,
    id: name,
    label: NAME_LABEL,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    validateFn: validationHandler,
    value: value
  });
};
svs.tickets_giftshop.gift.giftform.components.NameInput = NameInput;

 })(window);